import React from "react";
import { withRouter } from "react-router-dom";
import CardLessDataTable from "../../datatables/CardLessDataTableWithSearch";
import { Form, Container, Col, Row } from "react-bootstrap";
import MultiSelect from "react-multi-select-component";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withApollo } from "react-apollo";

// ✅ GraphQL Queries & Mutations
const GET_EXAM_ACCESS_STUDENTS = gql`
  query ($exam_paper_id: Int!) {
    getExamAccessUsers(exam_paper_id: $exam_paper_id) {
      mobile
      student_name
      section_id
      section_name
      is_access
    }
  }
`;

const UPDATE_USER_ACCESS = gql`
  mutation UpdateUserExamAccess($exam_paper_id: Int!, $userAccessList: [UserAccessList]!) {
    updateUserExamAccess(exam_paper_id: $exam_paper_id, userAccessList: $userAccessList)
  }
`;

class ExamAccessStudents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sections: [],
      sectionSelectedvalue: [],
      sectionError: "",
      students: [],
      originalStudents: [], // 🆕 Store initial snapshot
      selectedStudentError: "",
      loadingSpinner: 0,
      submitError: "",
      successMessage: "", // 🆕 For success message
    };
  }

  componentDidMount() {
    this.syncDataWithProps(this.props);
  }

  componentDidUpdate(prevProps) {
    if (this.props.getExamAccessUsers !== prevProps.getExamAccessUsers) {
      this.syncDataWithProps(this.props);
    }
  }

  // ✅ Sync GraphQL data → local state
  syncDataWithProps = (props) => {
    const newData = props.getExamAccessUsers?.getExamAccessUsers;

    if (newData && Array.isArray(newData) && newData.length > 0) {
      const uniqueSections = [
        ...new Map(
          newData.map((item) => [
            item.section_id,
            { value: item.section_id, label: item.section_name },
          ])
        ).values(),
      ];

      this.setState((prevState) => ({
        students: newData,
        originalStudents: JSON.parse(JSON.stringify(newData)), // keep immutable copy
        sections: uniqueSections,
        sectionSelectedvalue:
          prevState.sectionSelectedvalue.length === 0 ? uniqueSections : prevState.sectionSelectedvalue,
      }));
    }
  };

  // ✅ Toggle single checkbox
  handleCheckboxChange = (mobile) => {
    this.setState((prevState) => ({
      students: prevState.students.map((student) =>
        student.mobile === mobile
          ? { ...student, is_access: student.is_access === 1 ? 0 : 1 }
          : student
      ),
      selectedStudentError: "",
      submitError: "",
    }));
  };

  // ✅ Toggle all checkboxes
  handleSelectAll = (e) => {
    const { checked } = e.target;
    this.setState((prevState) => ({
      students: prevState.students.map((student) => ({
        ...student,
        is_access: checked ? 1 : 0,
      })),
      selectedStudentError: "",
    }));
  };

  // ✅ Handle section filter change
  handleMultipleSelectInputChange = (e, name) => {
    if (name === "section") {
      const sectionSelectedvalue = e
        ? e.map((val) => ({ label: val.label, value: val.value }))
        : [];

      this.setState({
        sectionSelectedvalue,
        sectionError: "",
        selectedStudentError: "",
        submitError: "",
      });

      // 🆕 Clear table if all unselected
      if (sectionSelectedvalue.length === 0) {
        this.setState({ filteredStudents: [] });
      }
    }
  };

  // ✅ Submit Form
  handleSubmit = async (e) => {
    e.preventDefault();
    const { sectionSelectedvalue, students, originalStudents } = this.state;

    if (!sectionSelectedvalue.length) {
      this.setState({ sectionError: "Please select Section" });
      return;
    }

    // 🆕 Compare and find changed users only
    const changedUsers = students.filter((student) => {
      const original = originalStudents.find((s) => s.mobile === student.mobile);
      return original && original.is_access !== student.is_access;
    });

    if (changedUsers.length === 0) {
      this.setState({
        successMessage: "No changes to update.",
        submitError: "",
        loadingSpinner: 0,
      });
      return;
    }

    const params = {
      exam_paper_id: parseInt(this.props.location?.state?.exam_id, 10),
      userAccessList: changedUsers.map((item) => ({
        mobile: item.mobile,
        is_access: item.is_access,
      })),
    };

    this.setState({ loadingSpinner: 1, successMessage: "", submitError: "" });

    try {
      await this.updateUserExamAccess(params);

      this.setState({
        loadingSpinner: 0,
        successMessage: "✅ Successfully Updated!",
      });

      // 🆕 Refresh original snapshot for next comparison
      this.setState({
        originalStudents: JSON.parse(JSON.stringify(this.state.students)),
      });

      // 🆕 Redirect after delay
      setTimeout(() => {
        this.props.history.push("/");
      }, 1500);
    } catch (error) {
      console.error("Mutation error:", error);
      this.setState({
        submitError:
          error.graphQLErrors?.map((x) => x.message).join(", ") || "Error occurred",
        loadingSpinner: 0,
      });
    }
  };

  // ✅ GraphQL mutation
  updateUserExamAccess = async (params) => {
    return this.props.updateUserExamAccess({
      variables: {
        exam_paper_id: params.exam_paper_id,
        userAccessList: params.userAccessList,
      },
    });
  };

  render() {
    const {
      sections,
      sectionSelectedvalue,
      sectionError,
      selectedStudentError,
      students,
      loadingSpinner,
      successMessage,
      submitError,
    } = this.state;

    const getStudents = this.props.getExamAccessUsers;
    const loading2 = getStudents.loading;
    const error2 = getStudents.error;

    if (loading2) {
      return (
        <div className="justify-content-center d-flex align-items-center">
          <div className="spinner-border text-primary text-center my-4"></div>
        </div>
      );
    }

    if (error2) {
      alert("Server Error. " + error2.message);
      return null;
    }

    // ✅ Filter students by selected sections
    const filteredStudents =
      sectionSelectedvalue.length > 0
        ? students.filter((item) =>
            sectionSelectedvalue.some((sec) => +sec.value === +item.section_id)
          )
        : [];

    // ✅ Table columns
    const articlecolumns = [
      {
        dataField: "select",
        text: (
          <input
            type="checkbox"
            onChange={this.handleSelectAll}
            checked={
              filteredStudents.length > 0 &&
              filteredStudents.every((s) => s.is_access === 1)
            }
          />
        ),
        formatter: (cell, row) => (
          <input
            type="checkbox"
            checked={row.is_access === 1}
            onChange={() => this.handleCheckboxChange(row.mobile)}
          />
        ),
      },
      { dataField: "student_name", text: "Student Name" },
      { dataField: "mobile", text: "Mobile" },
      { dataField: "section_name", text: "Section Name" },
    ];

    return (
      <Container fluid className="py-4">
        <div style={{ width: "100%", background: "#fff", borderRadius: 16, border: "1px solid #e2e8f0", boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden" }}>
          {/* ── Header ── */}
          <div style={{ background: "linear-gradient(135deg,#6366f1,#8b5cf6)", padding: "18px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
            <div className="d-flex align-items-center" style={{ gap: 12 }}>
              <div style={{ width: 42, height: 42, borderRadius: 10, background: "rgba(255,255,255,0.18)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <i className="fal fa-user-check" style={{ color: "#fff", fontSize: 20 }} />
              </div>
              <div>
                <div style={{ color: "#fff", fontWeight: 700, fontSize: 17 }}>Exam Access — Students</div>
                <div style={{ color: "rgba(255,255,255,0.85)", fontSize: 12 }}>Grant or revoke exam access by section</div>
              </div>
            </div>
            <div className="d-flex align-items-center" style={{ gap: 10 }}>
              <span style={{ background: "rgba(255,255,255,0.2)", color: "#fff", borderRadius: 20, padding: "4px 14px", fontSize: 13, fontWeight: 700 }}>
                {filteredStudents.length} Students
              </span>
              <button
                type="button"
                onClick={() => this.props.history.goBack()}
                className="d-flex align-items-center"
                style={{ background: "rgba(255,255,255,0.18)", border: "1px solid rgba(255,255,255,0.45)", color: "#fff", borderRadius: 8, padding: "6px 16px", fontWeight: 700, fontSize: 13, cursor: "pointer" }}
              >
                <i className="fal fa-arrow-left mr-2" />Back
              </button>
            </div>
          </div>

          <Form className="p-4" onSubmit={this.handleSubmit}>
            {/* ── Status alerts ── */}
            {successMessage && (
              <div className="d-flex align-items-center mb-3" style={{ background: "#ecfdf5", border: "1px solid #a7f3d0", color: "#047857", borderRadius: 10, padding: "10px 14px", fontSize: 14, fontWeight: 600 }}>
                <i className="fal fa-check-circle mr-2" />{successMessage}
              </div>
            )}
            {submitError && (
              <div className="d-flex align-items-center mb-3" style={{ background: "#fef2f2", border: "1px solid #fecaca", color: "#b91c1c", borderRadius: 10, padding: "10px 14px", fontSize: 14, fontWeight: 600 }}>
                <i className="fal fa-exclamation-circle mr-2" />{submitError}
              </div>
            )}

            {/* ── Section filter ── */}
            <Row>
              <Col lg={4} md={6} sm={12}>
                <label className="text-uppercase" style={{ fontSize: 12, fontWeight: 700, color: "#6b7280", letterSpacing: ".4px", marginBottom: 6, display: "block" }}>
                  <i className="fal fa-layer-group mr-2" style={{ color: "#6366f1" }} />Section
                </label>
                <MultiSelect
                  overrideStrings={{
                    allItemsAreSelected: "All Sections are selected.",
                    selectSomeItems: "Select Section",
                  }}
                  hasSelectAll={true}
                  disableSearch={false}
                  options={sections}
                  value={sectionSelectedvalue}
                  onChange={(e) => this.handleMultipleSelectInputChange(e, "section")}
                  labelledBy={"section"}
                />
                <Form.Text className="form-text text-danger">{sectionError}</Form.Text>
              </Col>
            </Row>

            {/* ── Students table ── */}
            <div style={{ border: `1px solid ${selectedStudentError ? "#ef4444" : "#e5e7eb"}`, borderRadius: 12, padding: 16, marginTop: 18, background: "#fff" }}>
              <CardLessDataTable
                parentData={filteredStudents || []}
                particlecolumns={articlecolumns}
                name="attendance"
                searchBar={true}
              />
              {selectedStudentError && (
                <Form.Text className="form-text text-danger h6 d-flex justify-content-end">
                  {selectedStudentError}
                </Form.Text>
              )}
            </div>

            {/* ── Submit ── */}
            <div className="d-flex justify-content-end mt-4">
              <button
                type="submit"
                className="d-flex align-items-center justify-content-center text-uppercase"
                disabled={loadingSpinner === 1}
                style={{
                  background: "linear-gradient(135deg,#6366f1,#8b5cf6)",
                  fontSize: 13,
                  fontWeight: 700,
                  letterSpacing: ".3px",
                  color: "#ffffff",
                  border: "none",
                  borderRadius: 10,
                  padding: "11px 32px",
                  cursor: loadingSpinner === 1 ? "not-allowed" : "pointer",
                  opacity: loadingSpinner === 1 ? 0.7 : 1,
                }}
              >
                {loadingSpinner === 1 ? (
                  <span className="spinner-border spinner-border-sm" />
                ) : (
                  <><i className="fal fa-save mr-2" />Submit</>
                )}
              </button>
            </div>
          </Form>
        </div>
      </Container>
    );
  }
}

export default withRouter(
  withApollo(
    compose(
      graphql(GET_EXAM_ACCESS_STUDENTS, {
        options: (props) => ({
          variables: {
            exam_paper_id: parseInt(props.location?.state?.exam_id, 10),
          },
          fetchPolicy: "cache-and-network",
        }),
        name: "getExamAccessUsers",
      }),
      graphql(UPDATE_USER_ACCESS, { name: "updateUserExamAccess" })
    )(ExamAccessStudents)
  )
);
